import { ConcreteEncodable } from "./ConcreteEncodable";

import { TradingCalendarSnapShotImplEncoder } from "../../encoder/TradingCalendarSnapShotImplEncoder";

import * as CubiqTS from "../../index";
import { TradingCalendarSnapShot } from "../TradingCalendarSnapShot";

export class TradingCalendarSnapShotImpl
  extends ConcreteEncodable
  implements TradingCalendarSnapShot
{
  public static enType: string = "com.bcdfx.model.calendar.TradingCalendarSnapShotImpl";

  /*FID=1*/
  public calendarRun: Array<CubiqTS.TradingCalendarRun> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TradingCalendarSnapShotImplEncoder.Instance;
    this.setEncodableType(TradingCalendarSnapShotImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TradingCalendarSnapShotImpl[" +
      "calendarRun=" +
      this.calendarRun +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
